'use client'

import { useRouter } from 'next/navigation'
import Icon from '@/components/icon/Icon'
import styles from './ua.module.scss'
import Button from '@/components/button/Button'
import StickyBar from '@/components/nav/StickyBar'

export default function BackButtonBar(props) {
  
  const router = useRouter()

  const renderBar = () => {
    return <div className={styles.bbb}>
      <div>
        <Button theme={['inline','plain']} label={"Back"} onClick={e => router.back()}>
          <Icon {...props} name="chevron-left"></Icon>
          <span>{ props.label || 'Back' }</span>
        </Button>
      </div>
      <div>
        { props.children }
      </div>
    </div>
  }

  if (props.onlyButton) {
    return <Button theme={['inline','plain']} label={"Back"} onClick={e => router.back()}>
      <Icon {...props} name="chevron-left"></Icon>
    </Button>

  }
  
  if (props.sticky) {
    return <StickyBar stickyStyle={props.stickyStyle} desktop={props.desktop} mobile={props.mobile} location="top">
      { renderBar() }
    </StickyBar>
  } else {
    return renderBar()
  }
  
}

